export default __webpack_public_path__ + "static/media/problema-01.b48c40e7.webp";